var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { StackView, STACK_ALIGN, STACK_DIRECTION, STACK_DISTRIBUTION } from "../StackView";
import { Text } from "../Text";
import { X_AXIS, Y_AXIS } from "../Popover";
import { useDropdown } from "../controls";
import { BASE_BORDER_WIDTH, createUIElement, SPACING_M } from "../helpers";
import { ICON_SIZES, Icon } from "../Icon";
import { InfoStatusIcon, ErrorStatusIcon, SuccessStatusIcon, WarningStatusIcon, CloseIcon } from "../icons";
import { STATUSES as SIGN_POST_VIEW } from "../common/public";
var VIEW_ICONS = (_a = {},
    _a[SIGN_POST_VIEW.info] = React.createElement(InfoStatusIcon, null),
    _a[SIGN_POST_VIEW.error] = React.createElement(ErrorStatusIcon, null),
    _a[SIGN_POST_VIEW.success] = React.createElement(SuccessStatusIcon, null),
    _a[SIGN_POST_VIEW.warning] = React.createElement(WarningStatusIcon, null),
    _a);
var getColorByView = function (_a) {
    var view = _a.view, theme = _a.theme, color = _a.color;
    if (color) {
        return color;
    }
    switch (view) {
        case SIGN_POST_VIEW.info:
            return theme === null || theme === void 0 ? void 0 : theme.colorStripeAccent;
        case SIGN_POST_VIEW.error:
            return theme === null || theme === void 0 ? void 0 : theme.colorBorderError;
        case SIGN_POST_VIEW.warning:
            return theme === null || theme === void 0 ? void 0 : theme.colorBorderWarning;
        default:
            return theme === null || theme === void 0 ? void 0 : theme.colorBorderSuccess;
    }
};
var Root = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    box-sizing: border-box;\n    ", ";\n    ", ";\n    position: relative;\n    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.25);\n\n    &::after {\n        content: '';\n        position: absolute;\n        ", ";\n        ", ";\n        top: 0;\n        left: 0;\n        bottom: 0;\n    }\n"], ["\n    box-sizing: border-box;\n    ",
    ";\n    ",
    ";\n    position: relative;\n    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.25);\n\n    &::after {\n        content: '';\n        position: absolute;\n        ",
    ";\n        ",
    ";\n        top: 0;\n        left: 0;\n        bottom: 0;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        width: ", ";\n        padding: ", ";\n        background: ", ";\n        border: ", " solid ", ";\n    "], ["\n        width: ", ";\n        padding: ", ";\n        background: ", ";\n        border: ", " solid ", ";\n    "])), theme.sizes.fields.xl, theme.spacing.xs, theme.colorBackgroundBlank, BASE_BORDER_WIDTH, theme.colorBorderMain);
}, function (_a) {
    var width = _a.width;
    return width && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            width: ", ";\n        "], ["\n            width: ", ";\n        "])), width);
}, function (_a) {
    var theme = _a.theme;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            background: ", ";\n            width: ", ";\n        "], ["\n            background: ", ";\n            width: ", ";\n        "])), theme.colorStripeAccent, theme.spacing.xs);
}, function (_a) {
    var view = _a.view, color = _a.color, theme = _a.theme;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            background: ", ";\n        "], ["\n            background: ", ";\n        "])), getColorByView({ view: view, theme: theme, color: color }));
});
var TextInfo = styled(Text)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    word-break: keep-all; /* for support IE */\n    word-break: break-word; /* for support Chrome */\n    overflow: hidden;\n\n    ", "\n"], ["\n    word-break: keep-all; /* for support IE */\n    word-break: break-word; /* for support Chrome */\n    overflow: hidden;\n\n    ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        padding: ", " ", ";\n    "], ["\n        padding: ", " ", ";\n    "])), theme.spacing.xs, theme.spacing.s);
});
var ButtonClose = styled.button(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    padding: 0;\n    outline: 0;\n    margin: 0;\n    border: 0;\n    cursor: default;\n    line-height: 1;\n    height: ", ";\n    width: ", ";\n    background: transparent;\n\n    ", "\n"], ["\n    padding: 0;\n    outline: 0;\n    margin: 0;\n    border: 0;\n    cursor: default;\n    line-height: 1;\n    height: ", ";\n    width: ", ";\n    background: transparent;\n\n    ",
    "\n"])), SPACING_M, SPACING_M, function (_a) {
    var theme = _a.theme;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        &:hover {\n            background: ", ";\n        }\n\n        &:active {\n            background: ", ";\n        }\n    "], ["\n        &:hover {\n            background: ", ";\n        }\n\n        &:active {\n            background: ", ";\n        }\n    "])), theme.colorHighlightLight, theme.colorHighlightDark);
});
var IconInfo = styled(Icon)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    cursor: pointer;\n"], ["\n    cursor: pointer;\n"])));
export var SIGN_POST_POSITIONS = {
    topRight: { xAxis: X_AXIS.insideLeft, yAxis: Y_AXIS.outsideTop, offsetX: 5, offsetY: -8 },
    topLeft: { xAxis: X_AXIS.outsideLeft, yAxis: Y_AXIS.outsideTop, offsetX: 10, offsetY: -8 },
    bottomRight: { xAxis: X_AXIS.insideLeft, yAxis: Y_AXIS.outsideBottom, offsetX: 6, offsetY: 8 },
    bottomLeft: { xAxis: X_AXIS.outsideLeft, yAxis: Y_AXIS.outsideBottom, offsetX: 10, offsetY: 8 },
    right: { xAxis: X_AXIS.outsideRight, yAxis: Y_AXIS.insideTop, offsetX: 8, offsetY: 0 },
    left: { xAxis: X_AXIS.outsideLeft, yAxis: Y_AXIS.insideTop, offsetX: -8, offsetY: 0 }
};
var DEFAULT_POSITIONS = [
    SIGN_POST_POSITIONS.topRight,
    SIGN_POST_POSITIONS.topLeft,
    SIGN_POST_POSITIONS.bottomRight,
    SIGN_POST_POSITIONS.bottomLeft,
    SIGN_POST_POSITIONS.right,
    SIGN_POST_POSITIONS.left
];
export var SignPost = createUIElement('SignPost', function (_a, ref) {
    var className = _a.className, initialShownState = _a.initialShownState, width = _a.width, text = _a.text, _b = _a.view, view = _b === void 0 ? SIGN_POST_VIEW.info : _b, color = _a.color, _c = _a.positions, positions = _c === void 0 ? DEFAULT_POSITIONS : _c, children = _a.children, iconSrc = _a.iconSrc, icon = _a.icon, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "initialShownState", "width", "text", "view", "color", "positions", "children", "iconSrc", "icon", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var rootRef = useRef(null);
    var controlRef = ref || rootRef;
    var control = useDropdown({
        ref: controlRef,
        initialActiveState: initialShownState,
        popoverConfig: positions,
        renderControl: function (_a) {
            var button = _a.button;
            return (React.createElement(IconInfo, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'control', className: "vm-SignPost " + className, src: icon || iconSrc || VIEW_ICONS[view] || VIEW_ICONS[SIGN_POST_VIEW.info], onClick: onClick, onMouseDown: function (e) {
                    button.onMouseDown(e);
                    onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
                }, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: function (e) {
                    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                }, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: button.ref, style: style })));
        },
        renderPopover: function (_a) {
            var popover = _a.popover, actions = _a.actions;
            return (React.createElement(Root, __assign({}, popover, { width: width, view: view, color: color }),
                React.createElement(StackView, { direction: STACK_DIRECTION.row, align: STACK_ALIGN.start, distribution: STACK_DISTRIBUTION.between },
                    React.createElement(TextInfo, null, text || children),
                    React.createElement(ButtonClose, { onClick: function () { return actions.hide(); } },
                        React.createElement(Icon, { size: ICON_SIZES.m, "data-selector-id": 'close', src: React.createElement(CloseIcon, null) })))));
        }
    })[0];
    return control;
});
export { STATUSES as SIGN_POST_VIEW } from "../common";
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=SignPost.js.map